module.exports = __webpack_public_path__ + "static/media/454A9280.cf8af379.jpg";